document.addEventListener("quantity:change", async (event) => {
  const { key, quantity } = event.detail;

  // Disable all quantity controls during update
  document.querySelectorAll("quantity-control").forEach((control) => {
    control.classList.add("updating");
    control.querySelectorAll("button, input").forEach((el) => {
      el.disabled = true;
    });
  });

  try {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity }),
    });

    await refreshCartDropdown();
  } finally {
    // Re-enable quantity controls after update
    document.querySelectorAll("quantity-control").forEach((control) => {
      control.classList.remove("updating");
      control.querySelectorAll("button, input").forEach((el) => {
        el.disabled = false;
      });
    });
  }
});

document.addEventListener("cart:change", async () => {
  await refreshCartDropdown();
});

document.addEventListener("cart:refresh", async () => {
  await refreshCartDropdown();
  document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
});

document.addEventListener("cart:add", async () => {
  await refreshCartDropdown();
  if (window.shouldReloadOnAddToCart) {
    window.location.reload();
    window.shouldReloadOnAddToCart = false;
    sessionStorage.setItem('cartReloaded', 'true');
    return;
  }
  document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
});

document.addEventListener("cart:open", async () => {
  openCartDropdown();
});

async function refreshCartDropdown() {
  const response = await fetch(
    `/?sections=cart-dropdown&timestamp=${Date.now()}`
  );
  const data = await response.json();
  const temp = document.createElement("div");
  temp.innerHTML = data["cart-dropdown"];

  const newDropdown = temp.querySelector(
    "#cart-dropdown #cart-dropdown-content"
  );
  const currentDropdown = document.querySelector(
    "#cart-dropdown #cart-dropdown-content"
  );

  if (currentDropdown && newDropdown) {
    currentDropdown.replaceWith(newDropdown);
  }

  document.dispatchEvent(new Event("cart:refreshed"));
  console.log("Cart dropdown refreshed.");
}

function openCartDropdown() {
  document.getElementById("cart-dropdown")?.classList.add("expanded");

  const deliveryDesktop = document.querySelector(".header-delivery__desktop");
  if (deliveryDesktop) {
    deliveryDesktop.classList.add("hidden");
  }

  const toggle = document.getElementById("header__cart-dropdown-toggle");
  if (toggle) {
    toggle?.classList.add("active");
    toggle.active = true;
  }
}


document.addEventListener("DOMContentLoaded", () => {
  if (sessionStorage.getItem('cartReloaded') === 'true') {
    sessionStorage.removeItem('cartReloaded');
    document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
  }
});